
if (!customElements.get('fvb-random-layout-hotspots')) {
  const closePopup = (hotspot) => {
    hotspot.classList.remove('is-active');
    hotspot.querySelector('.hotspot-btn')?.setAttribute('aria-expanded', 'false');
  };

  class FvbRandomLayoutHotspots extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
    }

    #handleClick = (event) => {
      const button = event.target.closest('.hotspot-btn');
      if (!button) return;

      const hotspot = button.closest('.hotspot');
      const shouldOpen = !hotspot.classList.contains('is-active');

      this.#closeAll();

      if (shouldOpen) {
        hotspot.classList.add('is-active');
        button.setAttribute('aria-expanded', 'true');
      }
    };

    #closeAll() {
      this.querySelectorAll('.hotspot.is-active').forEach(closePopup);
    }
  }

  customElements.define('fvb-random-layout-hotspots', FvbRandomLayoutHotspots);

  // Clicking/tapping anywhere outside a hotspot closes any open popup. Bound
  // once here, not per instance.
  document.addEventListener('click', (event) => {
    if (event.target.closest('.hotspot')) return;
    document.querySelectorAll('.hotspot.is-active').forEach(closePopup);
  });
}
